import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { BModal } from 'bootstrap-vue';
import FileExportsList from './FileExportsList.vue';
import { useAhNotificationState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileExportsModal',
  setup(__props) {

const modal = ref<InstanceType<typeof BModal> | null>(null);

const notificationState = useAhNotificationState();

const anyUnread = computed(() => notificationState.store.useNotificationsStore().fileExportUnreadCount > 0);

function show() {
  modal.value?.show();
}

function hide() {
  modal.value?.hide();
}

function markAllAsRead() {
  notificationState.store.useNotificationsStore().markAllAsRead('fileExports');
}

return { __sfc: true,modal, notificationState, anyUnread, show, hide, markAllAsRead, BModal, FileExportsList }
}

})